import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { ThemeProvider } from './theme/ThemeProvider';
import reportWebVitals from './reportWebVitals';
import api, { setupInterceptors } from './services/axios.config';
import { trackEvent } from './utils/analytics';

setupInterceptors(api);

// Global click tracking: any element with a `data-track` attribute is
// reported as a GA event, without needing to import analytics helpers into
// every component. `data-track-category` is optional (defaults to 'UI').
document.addEventListener('click', (e) => {
  const el = e.target.closest('[data-track]');
  if (!el) return;
  trackEvent('click', el.dataset.trackCategory || 'UI', el.dataset.track);
});

// Suppress harmless ResizeObserver warnings
// These occur when ResizeObserver callbacks trigger layout changes
// and are common with Radix UI components (Dialog, Popover, etc.)
const originalError = console.error;
console.error = (...args) => {
  if (
    typeof args[0] === 'string' &&
    args[0].includes(
      'ResizeObserver loop completed with undelivered notifications'
    )
  ) {
    return;
  }
  originalError.apply(console, args);
};

// Also handle unhandled errors
window.addEventListener('error', (event) => {
  if (
    event.message &&
    event.message.includes(
      'ResizeObserver loop completed with undelivered notifications'
    )
  ) {
    event.preventDefault();
    return false;
  }
  return undefined;
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ThemeProvider>
    <App />
  </ThemeProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
